import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { IoCubeOutline, IoBusinessOutline, IoLayersOutline, IoAlertCircleOutline, IoMailOutline, IoCallOutline, IoLocationOutline } from 'react-icons/io5';

// Verejná, neprihlásenému návštevníkovi dostupná stránka obalu - napr. pre neskorší QR kód na obale.
// Zámerne mimo hlavného Routera (bez Header/Sidebar/AuthGuard) a bez Redux, aby fungovala nezávisle od prihlásenia.
const InfoRow = ({ icon: Icon, label, value }) => (
    <div className="d-flex align-items-start gap-2 mb-2">
        <Icon size={15} style={{ color: '#0B1157', marginTop: 2, flexShrink: 0 }} />
        <div>
            <div className="text-muted" style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>{label}</div>
            <div style={{ fontSize: 14, color: '#0B1157' }}>{value || '—'}</div>
        </div>
    </div>
);

const PublicPackagingUnitPage = () => {
    const { tenantId, publicId } = useParams();
    const [data, setData] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/api/packagingunit/public/${tenantId}/${publicId}`)
            .then(res => setData(res.data))
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    }, [tenantId, publicId]);

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#F4F5FE', padding: '32px 16px' }}>
            <div style={{ maxWidth: 640, margin: '0 auto' }}>
                <div className="d-flex align-items-center gap-2 mb-4">
                    <div style={{
                        width: 34, height: 34, borderRadius: 9, backgroundColor: '#0B1157',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    }}>
                        <IoCubeOutline size={18} style={{ color: '#4DFFFF' }} />
                    </div>
                    <span className="fw-semibold" style={{ color: '#0B1157', fontSize: 16 }}>EnviCloud</span>
                </div>

                {loading ? (
                    <div className="text-center text-muted py-5">Načítava sa...</div>
                ) : notFound || !data ? (
                    <div
                        className="text-center py-5 px-3"
                        style={{ backgroundColor: '#fff', border: '1px solid #E5E7F2', borderRadius: 14 }}
                    >
                        <IoAlertCircleOutline size={28} style={{ color: '#c3c7dc' }} />
                        <div className="mt-2" style={{ color: '#0B1157', fontWeight: 600 }}>Stránka nebola nájdená</div>
                        <div className="text-muted mt-1" style={{ fontSize: 13 }}>
                            Odkaz je neplatný, alebo majiteľ obalu túto stránku nesprístupnil.
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="mb-3 p-4" style={{ backgroundColor: '#fff', border: '1px solid #E5E7F2', borderRadius: 14 }}>
                            <h3 className="mb-2" style={{ color: '#0B1157' }}>{data.name}</h3>
                            <div className="d-flex flex-wrap gap-2">
                                {data.code && <span className="badge bg-light text-dark border">{data.code}</span>}
                                {data.packagingTypeLabel && <span className="badge bg-light text-dark border">{data.packagingTypeLabel}</span>}
                                {data.characterLabel && <span className="badge bg-light text-dark border">{data.characterLabel}</span>}
                            </div>
                        </div>

                        <div className="mb-3 p-4" style={{ backgroundColor: '#fff', border: '1px solid #E5E7F2', borderRadius: 14 }}>
                            <div className="d-flex align-items-center gap-2 pb-2 mb-3" style={{ borderBottom: '1px solid #EEF0F8' }}>
                                <IoBusinessOutline size={16} style={{ color: '#0B1157' }} />
                                <span className="fw-semibold" style={{ color: '#0B1157', fontSize: 14 }}>Zhotoviteľ obalu</span>
                            </div>
                            <InfoRow icon={IoBusinessOutline} label="Názov" value={data.manufacturer?.companyName} />
                            <InfoRow icon={IoLocationOutline} label="Adresa" value={data.manufacturer?.address} />
                            <InfoRow icon={IoBusinessOutline} label="IČO" value={data.manufacturer?.identificationNumber} />
                            <InfoRow icon={IoMailOutline} label="E-mail" value={data.manufacturer?.email} />
                            <InfoRow icon={IoCallOutline} label="Telefón" value={data.manufacturer?.contact} />
                        </div>

                        <div className="p-4" style={{ backgroundColor: '#fff', border: '1px solid #E5E7F2', borderRadius: 14 }}>
                            <div className="d-flex align-items-center gap-2 pb-2 mb-3" style={{ borderBottom: '1px solid #EEF0F8' }}>
                                <IoLayersOutline size={16} style={{ color: '#0B1157' }} />
                                <span className="fw-semibold" style={{ color: '#0B1157', fontSize: 14 }}>Zloženie obalu</span>
                            </div>
                            {Array.isArray(data.components) && data.components.length > 0 ? (
                                data.components.map((component, index) => (
                                    <div
                                        key={index}
                                        className="d-flex align-items-center justify-content-between py-2"
                                        style={{ borderBottom: index < data.components.length - 1 ? '1px solid #F1F2F6' : 'none', fontSize: 14 }}
                                    >
                                        <span style={{ color: '#0B1157' }}>{component.component}</span>
                                        <span className="text-muted">
                                            {[component.materialGroupLabel, component.materialLabel].filter(Boolean).join(' — ')}
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <div className="text-muted" style={{ fontSize: 13 }}>Zloženie obalu nebolo uvedené.</div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PublicPackagingUnitPage;
